angular.module('leanlaw').factory('alerts', ['$q', '$timeout', '$rootScope', '$log', function ($q, $timeout, $rootScope, $log) {
  let alerts = [];
  const Alert = function Alert(params) {
    this.content = params.content;
    this.subContent = params.subContent;
    this.type = params.type;
    this.timeout = params.timeout;
    this.clickable = params.clickable || false;
    // Random id string
    this.id = (+new Date() * Math.random()).toString(36).substring(0, 6);
    if (this.timeout == undefined) this.timeout = 5000;
    if (this.timeout > 0) {
      $timeout(() => {
        this.dismiss();
      }, this.timeout);
    }
    this.deferred = $q.defer();
  };
  Alert.prototype.dismiss = function () {
    const idx = alerts.findIndex(a => a.id == this.id);
    // Element has already been dismissed:
    if (idx == -1) return;
    alerts.splice(idx, 1);
    broadcastRemoval();
  };

  // Resolve click promise for those listening
  Alert.prototype.click = function () {
    // Resolve click promise
    this.deferred.resolve();
    if (this.clickable) this.dismiss();
  };
  const broadcastRemoval = function () {
    // Wait for render
    $timeout(() => {
      $rootScope.$emit('$ll-alert-remove');
    }, 0);
  };
  const broadcastAddition = function () {
    // Wait for render
    $timeout(() => {
      $rootScope.$emit('$ll-alert-add');
    }, 0);
  };
  const create = function create(params) {
    if (!params.hasOwnProperty('content')) throw new Error('New alerts must contain a content param');
    const alert = new Alert(params);
    alerts.push(alert);
    broadcastAddition();
    return alert.deferred.promise;
  };
  const getAlerts = function getAlerts() {
    return alerts;
  };
  const dismissAll = function dismissAll() {
    alerts = [];
    broadcastRemoval();
  };
  return {
    alerts,
    getAlerts,
    dismiss: dismissAll,
    create,
    error(message) {
      if (!message) return;
      if (JSON.stringify(message) == '{}') return;
      let content = '';
      let subContent;
      // We might be passed just a string, or an http object
      if (typeof message === 'string') {
        content = message;
      } else {
        content = 'An error occurred';
        subContent = JSON.stringify(message);
        if (message.body) {
          subContent = message.body.message;
        }
      }
      $log.error('Toast error:', content, subContent);
      return create({
        type: 'error',
        content,
        subContent
      });
    },
    warning(message) {
      return create({
        type: 'warn',
        content: message
      });
    },
    info(message) {
      return create({
        type: 'info',
        content: message
      });
    },
    success(message) {
      return create({
        type: 'success',
        content: message
      });
    }
  };
}]);